import Image from "./../image";

import CloseButton from "./../button/close-button";
import Text from "../text/text";
import Toast from "../toast/toast";
import { useEffect, useState } from "react";
import { useAppStore } from "@/store/appStore";
import { useNavigationStore } from "@/store/navigationStore";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useTranslation } from "react-i18next";
import { useExplorationStore } from "@/store/explorationStore";
import { getSupportedVenueData } from "@/types/supported-venue";
import { saveRoute } from "@/api/dwm_api";
import { EVENT, trackEvent } from "@/utils/analytics";
import { getVenueByShortName } from "@/utils/map-util";

export default function ShareDialog() {
  const setIsShareOpen = useAppStore((state) => state.setIsShareOpen);
  const navData = useNavigationStore((state) => state.navData);
  const chatType = useAppStore((state) => state.chatType);
  const userQuery = useNavigationStore((state) => state.userQuery);
  const { t } = useTranslation();

  const navTo = navData?.nav
    ? navData?.nav.length > 0
      ? navData?.nav[0].endPoi.name
      : ""
    : "";
  // const shareToken = navData?.nav
  //   ? navData?.nav.length > 0
  //     ? navData?.nav[0].share
  //     : ""
  //   : "";
  const [sharedLink, setSharedLink] = useState("");
  const [toast, setToast] = useState(false);
  const toastDuration = 3000;
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setIsChatOpen = useAppStore((state) => state.setIsChatOpen);
  const currentVenue = useExplorationStore((state) => state.currentVenue);
  const navCurrentVenue = useNavigationStore((state) => state.currentVenue);
  const apiNavFrom = useNavigationStore((state) => state.navFrom);
  const chatAnswer = useNavigationStore((state) => state.chatAnswer);
  // const navFrom =
  //   navData?.from === "none"
  //     ? apiNavFrom !== ""
  //       ? t(apiNavFrom)
  //       : t("xiqu_entrance")
  //     : navData?.from;

  useEffect(() => {
    generateShareLink();
  }, []);

  const showToast = () => {
    setToast(true);
    setTimeout(() => setToast(false), toastDuration);
  };

  const generateShareLink = async () => {
    if (isChatOpen) {
      setIsChatOpen(false);
    }

    if (chatType === CHAT_TYPE.NAVIGATION) {
      setIsShareOpen(true);
      const shareToken = await saveRoute(navData?.nav, navData?.message)
      const params = `t=${shareToken}&r=dwmshare`;
      const link = `${window.location.origin
        }/shareNavigation?${new URLSearchParams(params)}`;
      setSharedLink(link);
      trackEvent(EVENT.BTN_SHARE_CLICKED, { mode: 'navigation', sharedLink: link });
    } else if (chatType === CHAT_TYPE.SIMULATION) {
      setIsShareOpen(true);
      const params = `q=${userQuery}`;
      const link = `${window.location.origin
        }/shareSimulation?${new URLSearchParams(params)}`;
      setSharedLink(link);
      trackEvent(EVENT.BTN_SHARE_CLICKED, { mode: 'simulation', sharedLink: link });
    } else if (chatType === CHAT_TYPE.EXPLORATION) {
      setIsShareOpen(true);
      const params = `v=${currentVenue}`;
      const link = `${window.location.origin
        }/shareExploration?${new URLSearchParams(params)}`;
      setSharedLink(link);
      trackEvent(EVENT.BTN_SHARE_CLICKED, { mode: 'exploration', sharedLink: link });
    }
  };

  const getThumbnail = () => {
    if (chatType === CHAT_TYPE.SIMULATION) {
      return "/assets/img_share_simulation.png";
    } else if (chatType === CHAT_TYPE.NAVIGATION) {
      return `/assets/img_share_${navCurrentVenue}.jpg`;
    } else if (chatType === CHAT_TYPE.EXPLORATION) {
      return `/assets/img_share_${currentVenue}.jpg`;
    }
    return "/assets/img_share_xiqu.jpg";
  };

  const getVenueTranslation = (venueCode: string) => {
    const venue = getSupportedVenueData().find((v) =>
      v.features.some((feature: any) => feature.properties.code === venueCode)
    );

    return venue?.features[0]?.properties.name ?? venueCode;
  };

  const getVenueName = (venueShortName: string) => {

    const venue = getVenueByShortName(venueShortName)
    if (venue) {
      return venue.venueName
    }
    return venueShortName
  }

  const shareDetail = () => {
    if (chatType === CHAT_TYPE.NAVIGATION) {
      return (
        <div className="bg-white px-5 pt-5">
          <Text
            text={getVenueName(navCurrentVenue) ?? ""}
            className="primary-text-dark font-medium"
            size={18}
          />
          <div className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-5 bg-white py-6">
            <div className="text-gray-500 font-normal">
              <Text text="share_from" className="text-secondary" />
            </div>
            <div className="text-gray-900 font-medium">
              <Text
                text={apiNavFrom ?? ""}
                translate={false}
                className="primary-text-dark"
                size={17}
              />
            </div>
            <div className="text-gray-500 font-normal">
              <Text text="share_to" className="text-secondary" />
            </div>
            <div className="text-gray-900 font-medium">
              <Text text={navTo ?? ""} className="primary-text-dark" size={17} />
            </div>
          </div>
        </div>

      );
    } else if (chatType === CHAT_TYPE.SIMULATION) {
      return (
        <div className="bg-white px-5 py-6">
          <Text
            text={userQuery}
            translate={false}
            className="primary-text-dark"
            size={17}
          />
        </div>
      );
    } else if (chatType === CHAT_TYPE.EXPLORATION) {
      return (
        <div className="bg-white px-5 py-6">
          <div className="text-gray-500 font-normal">
            <Text text="share_venue" className="text-secondary" />
          </div>
          <Text
            text={getVenueTranslation(currentVenue)}
            className="primary-text-dark"
            size={17}
          />
        </div>
      );
    } else {
      return <></>;
    }
  };

  return (
    <div
      className="fixed inset-0 z-[59] flex items-center justify-center"
      style={{ zIndex: 54 }}
    >
      <div className="fixed w-full h-full bg-overlay-blur"></div>
      {toast && <Toast message={t("copied")} duration={toastDuration} />}
      <div className="w-full h-full z-[59] ">
        <div className="flex items-center justify-between p-[20px]">
          <div className="w-[40px]"></div>
          <CloseButton
            withGlassBg={true}
            onClick={() => setIsShareOpen(false)}
            goBack={false}
          />
        </div>
        <div className="absolute inset-0  flex items-center justify-center h-full w-[330px] mx-auto rounded-xl">
          <div className="share-card rounded-[24px] overflow-hidden">
            <Image
              src={getThumbnail()}
              alt="thumbnail"
              width={330}
              height={220}
            />
            {shareDetail()}

            <div className="bg-white pb-6">
              <button
                disabled={sharedLink === ""}
                className="btn-normal primary-btn flex justify-center items-center mx-auto"
                onClick={() => {
                  showToast();
                  navigator.clipboard.writeText(sharedLink);
                  trackEvent(EVENT.BTN_COPY_LINK, { sharedLink: sharedLink });
                }}
              >
                <Image
                  className="m-[3px] mr-[10px]"
                  src="/assets/icon_copy.png"
                  alt="copy icon"
                  width={20}
                  height={20}
                />
                <Text text="btn_copy" size={17} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
